"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var ExtEndpointModule_1 = require("../ext/ExtEndpointModule");
var ExtAdapter_1 = __importDefault(require("../modules/ExtAdapter"));
var ExtError_1 = require("../modules/ExtError");
var CommonExtType_1 = require("./CommonExtType");
var CommonExtAdapter = /** @class */ (function (_super) {
    __extends(CommonExtAdapter, _super);
    function CommonExtAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonExtAdapter.prototype.registryExtEndpointModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.extEndpointModulesManager.registryExtEndpointModule(CommonExtType_1.CommonExtType.WEB_PANEL, Promise.resolve().then(function () { return __importStar(require('../common/CommonExtPanelEndpointModule' /* webpackChunkName: "web-panel" */)); }))];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.extEndpointModulesManager.registryExtEndpointModule(CommonExtType_1.CommonExtType.WEB_POPUP, Promise.resolve().then(function () { return __importStar(require('../common/CommonExtPopupEndpointModule' /* webpackChunkName: "web-popup" */)); }))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonExtAdapter.prototype.getHostId = function () {
        return 'middemoext';
    };
    CommonExtAdapter.prototype.getSupUrl = function (extMain) {
        return '//hyext.msstatic.com/hy-ext-sup/test/index.html';
    };
    CommonExtAdapter.prototype.getSupHost = function (extMain) {
        return 'hyext.msstatic.com';
    };
    CommonExtAdapter.prototype.getWasmScriptUrl = function () {
        return 'https://hyext.msstatic.com/wasm/genUnionId.js';
    };
    CommonExtAdapter.prototype.showAuthConfirmModal = function (extMain, extEndpoint, container) {
        var isAuth = confirm("\u662F\u5426\u5141\u8BB8" + extMain.extName + "\u5C0F\u7A0B\u5E8F\u83B7\u53D6\u60A8\u7684\u864E\u7259\u8D26\u53F7\u4FE1\u606F");
        return isAuth ? Promise.resolve() : Promise.reject(new ExtError_1.ExtRejectAuthError());
    };
    CommonExtAdapter.prototype.showUnpublishedConfirmModal = function (extMain, extEndpoint, container) {
        var isAuth = confirm("\u5F53\u524D\u5C0F\u7A0B\u5E8F" + extMain.extName + "\u4E3A\u975E\u6B63\u5F0F\u7248\u672C\uFF0C\u6CA1\u6709\u7ECF\u8FC7\u5B8C\u6574\u7684\u5BA1\u6838\u548C\u8BC4\u4F30\uFF0C\u53EF\u80FD\u4F1A\u51FA\u73B0\u4E0D\u6B63\u5E38\u7684\u8868\u73B0\uFF0C\u662F\u5426\u63A5\u53D7");
        return Promise.resolve(isAuth);
    };
    CommonExtAdapter.prototype.handleMessage = function () {
        var _this = this;
        document.addEventListener('visibilitychange', function () {
            if (document.hidden) {
                _this.extEndpointModulesManager.extEndpointModuleList.forEach(function (extEndpointModule) {
                    extEndpointModule.postLifeLeaveForeground(_this);
                });
            }
            else {
                _this.extEndpointModulesManager.extEndpointModuleList.forEach(function (extEndpointModule) {
                    extEndpointModule.postLifeEnterForeground(_this);
                });
            }
        });
        return Promise.resolve();
    };
    // 本地消息
    CommonExtAdapter.prototype.onLocalMessage = function (extUuid, eventName, extType, handler) {
        return __awaiter(this, void 0, void 0, function () {
            var list;
            return __generator(this, function (_a) {
                list = this.extEndpointModulesManager.getExtEndpointModuleListWithExtUuid(extUuid).filter(function (m) { return m.extEndpoint.extType === extType; });
                if (list.length === 0) {
                    return [2 /*return*/, Promise.reject(new ExtError_1.ExtNotSupportError("\u627E\u4E0D\u5230\u5C0F\u7A0B\u5E8Fid\u3010" + extUuid + "\u3011\u5C0F\u7A0B\u5E8F\u7C7B\u578B\u3010" + extType + "\u3011"))];
                }
                else {
                    list.forEach(function (m) {
                        m.bus.getBus(ExtEndpointModule_1.BusType.LOCAL_MESSAGE).on(eventName, handler);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    CommonExtAdapter.prototype.offLocalMessage = function (extUuid, eventName, extType, handler) {
        return __awaiter(this, void 0, void 0, function () {
            var list;
            return __generator(this, function (_a) {
                list = this.extEndpointModulesManager.getExtEndpointModuleListWithExtUuid(extUuid).filter(function (m) { return m.extEndpoint.extType === extType; });
                if (list.length === 0) {
                    return [2 /*return*/, Promise.reject(new ExtError_1.ExtNotSupportError("\u627E\u4E0D\u5230\u5C0F\u7A0B\u5E8Fid\u3010" + extUuid + "\u3011\u5C0F\u7A0B\u5E8F\u7C7B\u578B\u3010" + extType + "\u3011"))];
                }
                else {
                    list.forEach(function (m) {
                        m.bus.getBus(ExtEndpointModule_1.BusType.LOCAL_MESSAGE).off(eventName, handler);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    CommonExtAdapter.prototype.postLocalMessage = function (extUuid, eventName, extType, message) {
        return __awaiter(this, void 0, void 0, function () {
            var list;
            return __generator(this, function (_a) {
                list = this.extEndpointModulesManager.getExtEndpointModuleListWithExtUuid(extUuid).filter(function (m) { return m.extEndpoint.extType === extType; });
                if (list.length === 0) {
                    return [2 /*return*/, Promise.reject(new ExtError_1.ExtNotSupportError("\u627E\u4E0D\u5230\u5C0F\u7A0B\u5E8Fid\u3010" + extUuid + "\u3011\u5C0F\u7A0B\u5E8F\u7C7B\u578B\u3010" + extType + "\u3011"))];
                }
                else {
                    list.forEach(function (m) {
                        m.bus.getBus(ExtEndpointModule_1.BusType.LOCAL_MESSAGE).emit(eventName, message);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    return CommonExtAdapter;
}(ExtAdapter_1["default"]));
exports["default"] = CommonExtAdapter;
